import { useBlockProps } from '@wordpress/block-editor';

export default function save({ attributes }) {
	const {
		logos,
		template,
		animationDuration,
		showAltText,
		logoSize,
		slideDirection,
		displayMode,
		wrapperBgColor,
		itemBgColor,
		itemBorderColor,
		itemBorderWidth,
		itemBorderRadius,
		altTextColor,
		showTooltip,
		tooltipPosition,
	} = attributes;

	const blockProps = useBlockProps.save();

	// ── Inline styles ───────────────────────────────────────────────
	const itemStyle = (() => {
		const s = {};
		if (itemBgColor)     s.background  = itemBgColor;
		if (itemBorderColor) s.borderColor = itemBorderColor;
		if (itemBorderWidth) { s.borderWidth = `${itemBorderWidth}px`; s.borderStyle = 'solid'; }
		if (itemBorderRadius !== undefined && itemBorderRadius !== null)
			s.borderRadius = `${itemBorderRadius}px`;
		return s;
	})();

	const wrapperStyle = (extra = {}) => ({
		...(wrapperBgColor ? { background: wrapperBgColor } : {}),
		...extra,
	});

	const altStyle = altTextColor ? { color: altTextColor } : {};

	// ── Logo item — tooltip bubble stored in DOM, JS moves it to fixed ─
	const renderItem = (logo, index, cls) => {
		const hasTooltip = showTooltip && logo.tooltip;
		return (
			<div
				key={index}
				className={`${cls}${hasTooltip ? ' has-tooltip' : ''}`}
				style={itemStyle}
				data-tooltip={hasTooltip ? logo.tooltip : undefined}
				data-tooltip-position={hasTooltip ? (tooltipPosition || 'top') : undefined}
			>
				{logo.link ? (
					<a href={logo.link} target="_blank" rel="noopener noreferrer">
						<img src={logo.url} alt={logo.alt} style={{ maxWidth: `${logoSize}px` }} />
						{showAltText && logo.alt && (
							<span className="logo-carousel__alt-text" style={altStyle}>{logo.alt}</span>
						)}
					</a>
				) : (
					<>
						<img src={logo.url} alt={logo.alt} style={{ maxWidth: `${logoSize}px` }} />
						{showAltText && logo.alt && (
							<span className="logo-carousel__alt-text" style={altStyle}>{logo.alt}</span>
						)}
					</>
				)}
				{/* Tooltip text node — JS will read data-tooltip and position:fixed it */}
				{hasTooltip && (
					<div className="logo-tooltip" aria-hidden="true">{logo.tooltip}</div>
				)}
			</div>
		);
	};

	return (
		<div {...blockProps}>

			{/* ── CAROUSEL ── */}
			{displayMode === 'carousel' && (
				<div
					className={`logo-carousel logo-carousel--${template} logo-carousel--${slideDirection}`}
					data-animation-duration={animationDuration}
					data-display-mode="carousel"
					style={wrapperStyle({ '--animation-duration': `${animationDuration}s` })}
				>
					<div className="logo-carousel__track">
						{logos.concat(logos).map((logo, i) => renderItem(logo, i, 'logo-carousel__item'))}
					</div>
				</div>
			)}

		</div>
	);
}